module.exports = __webpack_public_path__ + "static/media/Mopex AI.29bad2a2.jpg";